import 'scss/solutions/web-AR-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/web-AR-solution.js